import React from "react";
import "./AdminDashboard.css";
import "./Sidebar.css";

const Sidebar = ({ active, setActive, isOpen, closeSidebar }) => {
  const menuItems = [
    { key: "Dashboard", icon: "📊" },
    { key: "Users",     icon: "👥" },
    { key: "Admissions", icon: "📋" },
    { key: "Scholarships", icon: "🎓" },
    { key: "Magazines", icon: "📰" },
    { key: "Notices",   icon: "📢" },
    { key: "Gallery",   icon: "🖼️" },
    { key: "Polls",     icon: "🗳️" },
  ];

  return (
    <div className={`admin-sidebar ${isOpen ? "open" : ""}`}>
      {/* CLOSE BUTTON (MOBILE ONLY) */}
      <button className="close-btn-admin" onClick={closeSidebar}>
        ✕
      </button>

      <h2 className="sidebar-title">Admin Panel</h2>

      <ul className="sidebar-menu">
        {menuItems.map((item) => (
          <li
            key={item.key}
            className={active === item.key ? "active" : ""}
            onClick={() => {
              setActive(item.key);
              closeSidebar(); // auto close on selection
            }}
          >
            <span className="sidebar-icon">{item.icon}</span>
            {item.key}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
